<div class="dialog-header">
  <div class="icon-wrapper">
    <i class="bi bi-key-fill"></i>
  </div>

  <div class="title-text">
    <h2>API Key Created</h2>
    <span class="subtitle">This key will only be shown once</span>
  </div>
</div>


<mat-dialog-content class="dialog-content">
  <p class="warning-text">
    This API key will be shown <strong>only once</strong>.
    Please copy it and store it securely before closing this dialog.
  </p>

  <div class="api-key-container">
    <code class="api-key">{{ apiKey }}</code>

    <button
      type="button"
      class="copy-btn"
      (click)="copyKey(apiKey)"
      aria-label="Copy API key"
    >
      <i class="bi bi-copy"></i>
    </button>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="warn" (click)="closeDialog()">
    Close
  </button>
</mat-dialog-actions>
